export const ItemTypes = {
    Ring: "ring",
    Bracelet: "bracelet",
    LooseDiamond: "loose diamond",
    Necklace: "necklace",
    JewelryBox: "jewelry box",
    Watch: "watch",
    Gold: "gold",
};

export const ItemTypesPlural = {
    Ring: "Rings",
    Bracelet: "Bracelets",
    "Loose Diamond": "Loose Diamonds",
    Necklace: "Necklaces",
    "Jewelry Box": "Jewelry Boxes",
    Watch: "Watches",
    Earrings: "Earrings",
    Gems: "Gems",
    Gold: "Gold",
    Other: "Other",
};

export const Styles = {
    Solitaire: "solitaire",
    BridalSet: "bridal set",
    ThreeStone: "3 stone",
    Halo: "halo",
    Drop: "drop",
    Pendant: "pendant",
    Link: "link",
    Choker: "choker",
    Collar: "collar",
    Lariat: "lariat",
    Riviera: "riviera",
    Station: "station",
    Tennis: "Tennis",
    Charm: "charm",
    Slide: "slide",
    Bangle: "bangle",
    Other: "Other"
}

export const MetalTypes = {
    Other: "other",
    Platinum: "platinum",
    K24: "24k",
    K18: "18k",
    K14: "14k",
    Under10K: "10k or less"
}

export const DiamondClarity = {
    NotSure: "not sure",
    FL: "fl",
    IF: "if",
    VVS1: "vvs1",
    VVS2: "vvs2",
    VS1: "vs1",
    VS2: "vs2",
    SI1: "si1",
    SI2: "si2",
    I1: "i1",
    I2: "i2",
    I3: "i3"
}

export const DiamondColor = {
    NotSure: "not sure",
    D: "d",
    E: "e",
    F: "f",
    G: "g",
    H: "h",
    I: "i",
    J: "j",
    K: "k",
    L: "l",
    MtoZ: "m-z",
    Fancy: "fancy"
};

export const GemstoneColor = {
    Black: 'black',
    Colorless: 'colorless',
    Purple: 'purple',
    Blue: 'blue',
    Brown: 'brown',
    Gray: 'gray',
    Green: 'green',
    Orange: 'orange',
    Pink: 'pink',
    Red: 'red',
    White: 'white',
    Yellow: 'yellow',
    Multicolored: 'multicolored',
    NA: 'na',
};

export const DiamondShape = {
    Round: "round",
    Princess: "princess",
    Oval: "oval",
    Marquise: "marquise",
    Cushion: "cushion",
    Pear: "pear",
    Emerald: "emerald",
    Other: "other"
};

export const JewelryBrand = {
    Tiffany: 'tiffany co',
    Cartier: 'cartier',
    VanCleefArpens: 'van cleef arpens',
    HarryWinston: 'harry winston',
    Bvlgari: 'bvlgari',
    DavidYurman: 'david yurman',
    Other: 'other'
}

export const CertificateType = {
    None: "none",
    GIA: "gia",
    Other: "other"
}

export const FieldStyleToSimple = {
    'jewelry_style_ring_solitaire': Styles.Solitaire,
    'jewelry_style_ring_bridal_set': Styles.BridalSet,
    'jewelry_style_ring_3_stone': Styles.ThreeStone,
    'jewelry_style_ring_halo': Styles.Halo,
    'jewelry_style_ring_other': Styles.Other,
    'jewelry_style_bracelet_tennis': Styles.Tennis,
    'jewelry_style_bracelet_charm': Styles.Charm,
    'jewelry_style_bracelet_slide': Styles.Slide,
    'jewelry_style_bracelet_bangle': Styles.Bangle,
    'jewelry_style_bracelet_link': Styles.Link,
    'jewelry_style_bracelet_other': Styles.Other
}

export const FieldShapeToSimple = {
    'diamond_shape_round': DiamondShape.Round,
    'diamond_shape_princess': DiamondShape.Princess,
    'diamond_shape_cushion': DiamondShape.Cushion,
    'diamond_shape_marquise': DiamondShape.Marquise,
    'diamond_shape_emerald': DiamondShape.Emerald,
    'diamond_shape_other': DiamondShape.Other
}

export const FieldColorToSimple = {
    'diamond_color_d': DiamondColor.D,
    'diamond_color_e': DiamondColor.E,
    'diamond_color_f': DiamondColor.F,
    'diamond_color_g': DiamondColor.G,
    'diamond_color_h': DiamondColor.H,
    'diamond_color_i': DiamondColor.I,
    'diamond_color_j': DiamondColor.J,
    'diamond_color_k': DiamondColor.K,
    'diamond_color_l': DiamondColor.L,
    'diamond_color_m_z': DiamondColor.MtoZ,
    'diamond_color_fancy': DiamondColor.Fancy,
    'diamond_color_not_sure': DiamondColor.NotSure,
    'diamond_average_color_grade_d': DiamondColor.D,
    'diamond_average_color_grade_e': DiamondColor.E,
    'diamond_average_color_grade_f': DiamondColor.F,
    'diamond_average_color_grade_g': DiamondColor.G,
    'diamond_average_color_grade_h': DiamondColor.H,
    'diamond_average_color_grade_i': DiamondColor.I,
    'diamond_average_color_grade_j': DiamondColor.J,
    'diamond_average_color_grade_k': DiamondColor.K,
    'diamond_average_color_grade_l': DiamondColor.L,
    'diamond_average_color_grade_m_z': DiamondColor.MtoZ,
    'diamond_average_color_grade_fancy': DiamondColor.Fancy,
    'diamond_average_color_grade_not_sure': DiamondColor.NotSure,
}

export const FieldClarityToSimple = {
    'diamond_clarity_fl': DiamondClarity.FL,
    'diamond_clarity_if': DiamondClarity.IF,
    'diamond_clarity_vvs1': DiamondClarity.VVS1,
    'diamond_clarity_vvs2': DiamondClarity.VVS2,
    'diamond_clarity_vs1': DiamondClarity.VS1,
    'diamond_clarity_vs2': DiamondClarity.VS2,
    'diamond_clarity_si1': DiamondClarity.SI1,
    'diamond_clarity_si2': DiamondClarity.SI2,
    'diamond_clarity_i1': DiamondClarity.I1,
    'diamond_clarity_i2': DiamondClarity.I2,
    'diamond_clarity_i3': DiamondClarity.I3,
    'diamond_clarity_not_sure': DiamondClarity.NotSure,
    'diamond_average_clarity_grade_fl': DiamondClarity.FL,
    'diamond_average_clarity_grade_if': DiamondClarity.IF,
    'diamond_average_clarity_grade_vvs1': DiamondClarity.VVS1,
    'diamond_average_clarity_grade_vvs2': DiamondClarity.VVS2,
    'diamond_average_clarity_grade_vs1': DiamondClarity.VS1,
    'diamond_average_clarity_grade_vs2': DiamondClarity.VS2,
    'diamond_average_clarity_grade_si1': DiamondClarity.SI1,
    'diamond_average_clarity_grade_si2': DiamondClarity.SI2,
    'diamond_average_clarity_grade_i1': DiamondClarity.I1,
    'diamond_average_clarity_grade_i2': DiamondClarity.I2,
    'diamond_average_clarity_grade_i3': DiamondClarity.I3,
    'diamond_average_clarity_grade_not_sure': DiamondClarity.NotSure
}

export const FieldCertificateToSimple = {
    'diamond_certificate_none': CertificateType.None,
    'diamond_certificate_gia': CertificateType.GIA,
    'diamond_certificate_other': CertificateType.Other
}

export const FieldMetaTypeToSimple = {
    'jewelry_metal_type_10k_gold': MetalTypes.Under10K,
    'jewelry_metal_type_14k_gold': MetalTypes.K14,
    'jewelry_metal_type_18k_gold': MetalTypes.K18,
    'jewelry_metal_type_24k_gold': MetalTypes.K24,
    'jewelry_metal_type_platinum': MetalTypes.Platinum,
    'jewelry_metal_type_other': MetalTypes.Other,
}

export const FieldBrandToSimple = {
    'jewelry_brand_tiffany_co': JewelryBrand.Tiffany,
    'jewelry_brand_cartier': JewelryBrand.Cartier,
    'jewelry_brand_van_cleef_arpels': JewelryBrand.VanCleefArpens,
    'jewelry_brand_harry_winston': JewelryBrand.HarryWinston,
    'jewelry_brand_david_yurman': JewelryBrand.DavidYurman,
    'jewelry_brand_bvlgari': JewelryBrand.Bvlgari,
    'jewelry_brand_other': JewelryBrand.Other
}
